import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateProfile } from '../../controllers/user';

const PerfilMamaForm = forwardRef((props, ref) => {
  const [nombreEsposa, setNombreEsposa] = useState('');
  const [apellido, setApellido] = useState('');
  const [telefono, setTelefono] = useState('');
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  useEffect(() => {
      setNombreEsposa(props.perfil?.nombre1);
      setApellido(props.perfil?.apellido);
      setTelefono(props.perfil?.telefono1);
    }, [])

  useImperativeHandle(ref, () => ({
    getPerfil() {
      return generatePerfil();
    }
  }));

  function generatePerfil() {
    return {
      tipo: 'mama',
      nombre1: nombreEsposa,
      apellido,
      telefono1: telefono
    };
  }
  
  async function submitUpdate() {
    let p = generatePerfil();
    console.log(p);
    try {
      let r = await updateProfile(token, props.userId, p);
      setAlert(<Alert variant='success' onClose={() => setAlert()} dismissible>La información se actualizó con éxito.</Alert>);
    }
    catch (e) {
      console.log(e);
      setAlert(<Alert variant='danger' onClose={() => setAlert()} dismissible>Ocurrió un error. Por favor intenta de nuevo más tarde.</Alert>);
    }
  }

  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-perfil' type='submit' variant='primary' onClick={submitUpdate}>Actualizar perfil</Button>
      </Form.Group>;
    }
  }

  function handleChange(e) {
    const value = e.target.value;
    switch (e.target.name) {
      case 'nombreEsposa': setNombreEsposa(value); break;
      case 'apellido': setApellido(value); break;
      case 'telefono': setTelefono(value); break;
    }
  }

  return <Row>
    <Col>
      {alert}
      <Form.Group className="mb-3">
        <Form.Label>Nombre</Form.Label>
        <Form.Control type="text" placeholder="Nombre" name='nombreEsposa' value={nombreEsposa} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Apellido</Form.Label>
        <Form.Control type="text" placeholder="Apellido" name='apellido' value={apellido} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Teléfono</Form.Label>
        <Form.Control type="number" placeholder='Teléfono' name='telefono' value={telefono} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default PerfilMamaForm;